import { render, staticRenderFns } from "./vehicles.vue?vue&type=template&id=a4d1d068&scoped=true&"
var script = {}
import style0 from "./vehicles.vue?vue&type=style&index=0&id=a4d1d068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d1d068",
  null
  
)

export default component.exports